var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section reset-section"},[_c('h2',[_vm._v("Check your e-mail address to set new password")]),_c('div',{staticClass:"holder-img"},[_c('img',{attrs:{"src":require("@/assets/img/sign-up.svg"),"alt":"reset-img"}})]),_c('div',{staticClass:"reset-text"},[_c('p',[_vm._v("We send you an email to reset your password")])])])
}]

export { render, staticRenderFns }